import { Skeleton, Stack } from "@mantine/core";
import { MessageDetailCard } from "shared/components/message/MessageDetailCard";
import { arr } from "shared/utils/array";

export const MessageListSkeleton = () => (
    <Stack>
        {arr
            .make(4, (i) => (
                <Skeleton key={`message-list-skeleton-${i}`}>
                    <MessageDetailCard />
                </Skeleton>
            ))
            .take()}
    </Stack>
);
